export default __webpack_public_path__ + "static/media/bet11.17b948c3.png";